import React, { Suspense, lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import NyafazPortalFlowLayout from "./NyafazPortalFlowLayout";
import { PortalPageFallback } from "./components/PortalLoader";
import Login, { RequirePortalAuth } from "./pages/Login";
import { LegacyOrgDetailRedirect, renderEnterpriseControlRoutes } from "./enterprise-control/NaturalsControlRoutes";

const Organizations = lazy(() => import("./pages/Organizations"));
const PortalHome = lazy(() => import("./pages/PortalHome"));
const ProductRoutes = lazy(() => import("./pages/products/ProductRoutes"));
const CreateOrganization = lazy(() => import("./pages/CreateOrganization"));
const PortalPlansPage = lazy(() => import("./pages/PortalPlansPage"));
const ScanLimitsPage = lazy(() => import("./pages/ScanLimitsPage"));
const BillingNoticesPage = lazy(() => import("./pages/BillingNoticesPage"));
const InvoiceSupplierProfilePage = lazy(() => import("./pages/InvoiceSupplierProfilePage"));
const BillingSandboxPage = lazy(() => import("./pages/BillingSandboxPage"));
const AnalysisWhatsAppPage = lazy(() => import("./pages/AnalysisWhatsAppPage"));
const EscalatedComplaints = lazy(() => import("./pages/EscalatedComplaints"));
const PlanRequestsPage = lazy(() => import("./pages/PlanRequestsPage"));
const Analytics = lazy(() => import("./pages/Analytics"));
const ReleaseNotes = lazy(() => import("./pages/ReleaseNotes"));

const Fallback = () => <PortalPageFallback message="Loading page" submessage="Preparing enterprise portal…" />;

export function renderEnterprisePortalRoutes({ portalHome = false } = {}) {
  return (
    <Route element={<NyafazPortalFlowLayout />}>
      {portalHome ? <Route path="/" element={<Navigate to="/enterprise-portal" replace />} /> : null}
      <Route path="/enterprise-portal" element={<Login />} />
      <Route
        path="/enterprise-portal/home"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <PortalHome />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/organizations"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <Organizations />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/products/:productSlug/*"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <ProductRoutes />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/analytics/*"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <Analytics />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/plans"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <PortalPlansPage />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/scan-limits"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <ScanLimitsPage />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/billing-test"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <BillingSandboxPage />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/billing-emails"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <BillingNoticesPage />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/invoice-profile"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <InvoiceSupplierProfilePage />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/analysis-whatsapp"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <AnalysisWhatsAppPage />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/organizations/new"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <CreateOrganization />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/organizations/:orgId"
        element={
          <RequirePortalAuth>
            <LegacyOrgDetailRedirect />
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/organizations/:orgId/edit"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <CreateOrganization />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      {renderEnterpriseControlRoutes()}
      <Route
        path="/enterprise-portal/plan-requests"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <PlanRequestsPage />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/escalated-complaints"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <EscalatedComplaints />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/enterprise-portal/release-notes"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <ReleaseNotes />
            </Suspense>
          </RequirePortalAuth>
        }
      />
    </Route>
  );
}
